var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { spacing } from "syf-component-library/defaultTheme";
var BannerImage = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", ";\n  width: ", ";\n  margin-bottom: ", "px;\n"], ["\n  height: ", ";\n  width: ", ";\n  margin-bottom: ", "px;\n"])), function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var width = _a.width;
    return width;
}, spacing.base);
export default BannerImage;
var templateObject_1;
